import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { Button } from "../../atoms/Button";
import { CustomerInfoAuthForm } from "../../organisms/form/CustomerInfoAuthForm";
import { useCustomerInfoAuth } from "./hook";

export const CustomerInfoAuth: React.FC = () => {
  const { handleCustomerInfoAuth, backToRegistration } = useCustomerInfoAuth();

  return (
    <Container>
      <TitleWrapper>認証コード入力</TitleWrapper>
      <TitleContent>届いた認証コードを入力してください。</TitleContent>
      <Content>
        認証コードには有効期限があります。認証コードを受け取った後、30分以内に認証コードを入力して、「次へ」を押してください。
      </Content>
      <Content>
        このページを閉じたり更新した場合は、新規登録画面から認証コードを再発行してください。
      </Content>

      <CustomerInfoAuthForm handleSubmit={handleCustomerInfoAuth} />

      <ButtonWrapper>
        <Button
          btnStyle="secondary"
          text="新規会員登録へ戻る"
          onClick={backToRegistration}
          rounded="md"
        />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 51px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px 0;
  display: flex;
  font-weight: 600;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const TitleContent = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 8px;
  font-family: "Hiragino Sans";
`;

const Content = styled.p`
  text-align: left;
  margin-bottom: 32px;
  font-weight: 300;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 35px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
  }
`;
